"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isUserLeaderOfGroup = function isUserLeaderOfGroup(userGroupChallenge, user) {
  var _userGroupChallenge$m = userGroupChallenge.members,
      members = _userGroupChallenge$m === void 0 ? [] : _userGroupChallenge$m;
  var leaderMember = members.find(function (member) {
    return member.rank === 'leader';
  });
  return !!(leaderMember && leaderMember._id === user._id);
};

var _default = isUserLeaderOfGroup;
exports["default"] = _default;
//# sourceMappingURL=isUserLeaderOfGroup.js.map